import React from 'react';

import { type Collection } from '@pkg/graphql/codegen/graphql';

import { CollectionLink } from '@app/pages/Collection/components/CollectionLink';
import { ReactComponent as ChevronDown } from '@app/pages/NFTDetailView/assets/icons/chevron-down.svg';

import { type ActivityPanelVariants } from '../ActivityList';

import {
    CollectionImage,
    Collection as CollectionItem,
    CollectionName,
    Controls,
    MinimizeButton,
    Wrapper,
} from './styles';

interface Props {
    handleToggle: () => void;
    variant?: ActivityPanelVariants;
    collectionData?: Collection;
}

export const TopControls = ({ handleToggle, variant, collectionData }: Props) => {
    const { id, imageUrl: mashedThumbnail, name, slug } = collectionData || {};
    const [collectionChain, contract] = id?.split('.') || [];
    const collectionSlug = slug || `${contract}.${name}`;
    return (
        <Wrapper $showCompact={variant !== 'detail-view' && variant !== 'collection'}>
            {(variant === 'detail-view' || variant === 'collection') && (
                <CollectionItem>
                    {mashedThumbnail && <CollectionImage $image={mashedThumbnail} />}
                    {name && (
                        <CollectionName>
                            <CollectionLink chain={collectionChain} slug={collectionSlug}>
                                {name}
                            </CollectionLink>
                        </CollectionName>
                    )}
                </CollectionItem>
            )}

            <Controls $showCompact={variant !== 'detail-view' && variant !== 'collection'}>
                <MinimizeButton onClick={handleToggle}>
                    <ChevronDown />
                </MinimizeButton>
            </Controls>
        </Wrapper>
    );
};
